import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginToDashboard } from "../utils/dashboardApi";

export default function DashboardLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await loginToDashboard(password);
      navigate("/internal/dashboard");
    } catch (err) {
      setError(err.message || "เข้าสู่ระบบไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--brand-bg, #E6F3FC)",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#FFFFFF",
          borderRadius: 16,
          boxShadow: "0 12px 32px rgba(9,27,58,0.14)",
          padding: "40px 36px",
          width: "100%",
          maxWidth: 360,
        }}
      >
        <h1 style={{ fontSize: "1.3rem", marginBottom: 6, color: "var(--brand-secondary, #091B3A)" }}>
          Dashboard Login
        </h1>
        <p style={{ fontSize: "0.85rem", color: "#667", marginBottom: 24 }}>
          Internal analytics — authorized access only
        </p>

        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus
          style={{
            width: "100%",
            padding: "10px 14px",
            borderRadius: 8,
            border: "1px solid #DCE3E8",
            fontSize: "0.95rem",
            marginBottom: 14,
            boxSizing: "border-box",
          }}
        />

        {error && (
          <p style={{ color: "#C0392B", fontSize: "0.82rem", marginBottom: 14 }}>{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px 14px",
            borderRadius: 8,
            border: "none",
            background: "var(--brand-secondary, #091B3A)",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "0.9rem",
            cursor: loading ? "default" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
